<div class="flex-1 overflow-y-auto">
  <app-page-header
    [title]="'page.clients' | transloco"
    [actions]="headerActions"
  />

  <!-- SECTION: Liste des clients -->
  <section>
    <!-- Header avec divider -->
    <div class="mb-4 flex items-center gap-3">
      <div
        class="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100"
      >
        <lucide-icon
          name="users"
          class="text-primary-600"
          [size]="16"
        ></lucide-icon>
      </div>
      <h2
        class="flex items-baseline gap-1 text-lg font-semibold text-greyscale-800"
      >
        {{ "companyClientList.sectionTitle" | transloco }}
        <span class="font-normal text-greyscale-500"
          >({{ clients().length }})</span
        >
        <app-tooltip-icon
          [message]="'companyClientList.infoCardDescription' | transloco"
          position="right"
          iconClass="text-greyscale-400"
        />
      </h2>
    </div>
    <div class="mb-4 h-px bg-greyscale-200"></div>

    <div>
      @if (isLoading()) {
        <div class="flex h-64 items-center justify-center">
          <i class="pi pi-spin pi-spinner text-4xl text-primary-500"></i>
        </div>
      } @else if (clientsError()) {
        <div
          class="flex flex-col items-center justify-center py-12 text-center"
        >
          <div class="mb-4 rounded-full bg-red-100 p-4">
            <lucide-angular
              [img]="UsersIcon"
              [size]="48"
              class="text-red-400"
            ></lucide-angular>
          </div>
          <h3 class="mb-2 text-xl font-semibold text-greyscale-900">
            {{ "companyClientList.errorLoad" | transloco }}
          </h3>
          <p-button
            [label]="'companyClientList.retry' | transloco"
            icon="pi pi-refresh"
            severity="secondary"
            (onClick)="retryLoadClients()"
          ></p-button>
        </div>
      } @else if (clients().length) {
        <!-- Search Bar -->
        <div class="mb-6 flex items-center gap-2">
          <div class="rounded-lg border border-greyscale-200 bg-white">
            <p-iconfield>
              <p-inputicon styleClass="pi pi-search" />
              <input
                type="text"
                pInputText
                class="w-full border-0 md:w-80"
                [placeholder]="
                  'companyClientList.searchPlaceholder' | transloco
                "
                [ngModel]="searchQuery()"
                (ngModelChange)="onSearchChange($event)"
                data-testid="client.search.input"
              />
            </p-iconfield>
          </div>
          @if (isSearching()) {
            <i class="pi pi-spin pi-spinner text-primary-500"></i>
          }
        </div>

        <!-- Cards Grid -->
        @if (filteredClients().length > 0) {
          <div
            class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
          >
            @for (client of filteredClients(); track client.id) {
              <app-client-card
                [client]="client"
                (edit)="openEditDialog($event)"
                (delete)="confirmDelete($event)"
              />
            }
          </div>
        } @else if (!isSearching()) {
          <!-- No Search Results -->
          <div
            class="flex flex-col items-center justify-center py-12 text-center"
          >
            <div class="mb-4 rounded-full bg-greyscale-100 p-4">
              <lucide-angular
                [img]="UsersIcon"
                [size]="48"
                class="text-greyscale-400"
              ></lucide-angular>
            </div>
            <h3 class="mb-2 text-xl font-semibold text-greyscale-900">
              {{ "companyClientList.noSearchResults" | transloco }}
            </h3>
            <p class="text-sm text-greyscale-600">
              {{ "companyClientList.tryDifferentSearch" | transloco }}
            </p>
          </div>
        }
      } @else {
        <!-- Empty State -->
        <div
          class="flex flex-col items-center justify-center py-12 text-center"
        >
          <div class="mb-4 rounded-full bg-greyscale-100 p-4">
            <lucide-angular
              [img]="UsersIcon"
              [size]="48"
              class="text-greyscale-400"
            ></lucide-angular>
          </div>
          <h3 class="mb-2 text-xl font-semibold text-greyscale-900">
            {{ "companyClientList.emptyTitle" | transloco }}
          </h3>
          <p class="mb-6 max-w-md text-sm text-greyscale-600">
            {{ "companyClientList.emptyDescription" | transloco }}
          </p>
          <p-button
            [label]="
              'accountMenu.organizationsManagement.addClient' | transloco
            "
            icon="pi pi-plus"
            (onClick)="openCreateDialog()"
            data-testid="empty-state-add-client"
          ></p-button>
        </div>
      }
      <p-confirmDialog
        rejectButtonStyleClass="p-button-outlined"
      ></p-confirmDialog>
    </div>
  </section>

  <!-- Client Form Dialog -->
  <app-client-form-dialog
    [visible]="dialogVisible()"
    [mode]="dialogMode()"
    [client]="selectedClient()"
    [loading]="dialogLoading()"
    (visibleChange)="dialogVisible.set($event)"
    (save)="onSaveClient($event)"
  />
</div>
